export class ChannelCommomController {
    static $inject = ['domain', 'ConfigurationsService'];
    constructor(domain, ConfigurationsService) {
        this.domain = domain;
        this.ConfigurationsService = ConfigurationsService;
    }
    async getChannelConfigurations(useConfigurationsApplicationGet = false) {
        try {
            this.configurations = await this.ConfigurationsService.get(`postmaster@${this.domain}.gw.msging.net`, undefined, useConfigurationsApplicationGet);
            return true;
        }
        catch (ex) {
            this.configurations = undefined;
            // If there is no configuration for that domain
            if (ex.code == 67) {
                return true;
            }
            return false;
        }
        finally {
            this.setActivationStatus();
        }
    }
    async deleteChannelConfigurations(useConfigurationsApplicationSet = false, useConfigurationsApplicationGet = false) {
        try {
            await this.ConfigurationsService.delete(`postmaster@${this.domain}.gw.msging.net`, undefined, useConfigurationsApplicationSet);
            return true;
        }
        catch (ex) {
            return false;
        }
        finally {
            this.getChannelConfigurations(useConfigurationsApplicationGet);
        }
    }
    setActivationStatus() {
        this.isChannelActive = Boolean(this.configurations &&
            (this.configurations.IsChannelActive == 'True' ||
                this.configurations.IsChannelActive == 'true'));
    }
}
ChannelCommomController.$inject = ['domain', 'ConfigurationsService'];
